<template>
  <div id="programs-list">
    <spinner-round :is-loading="loading" v-if="loading" :spinnerStyle="{top: '160px'}"></spinner-round>
    <div v-else>
      <div v-if="programs && programs.length"
        class="columns is-gapless is-padding-left is-padding-right is-vcentered is-border-left is-border-right has-bg-white">
        <div class="column is-narrow">
          <div class="is-padding-top-small is-padding-bottom-small">
            <div v-if="panel == PANELS.CARDS"
              @click="changePanel(PANELS.TABLE)">
              <input id="changeStockPgmPanelTable" name="changeStockPgmPanelTable" class="switch is-success is-rounded" type="checkbox">
              <label for="changeStockPgmPanelTable" class="">Affichage des données en tableau</label>
            </div>
            <div v-if="panel == PANELS.TABLE"
              @click="changePanel(PANELS.CARDS)">
              <input id="changeStockPgmPanelTable" name="changeStockPgmPanelTable" class="switch is-success is-rounded" type="checkbox" checked="checked">
              <label for="changeStockPgmPanelTable" class="">Affichage des données en tableau</label>
            </div>

          </div>
        </div>
        <!-- <div class="column is-paddingless" v-if="programs && programs.length">
          <pagination :loading="loading"
                      @ChangePage="changePage"
                      :currentPage="currentPage"
                      :totalPage="totalPage"
                      :reverse="true"></pagination>
        </div> -->
      </div>

      <stock-program-card
                  :style="loading ? 'opacity: 0.4; cursor: wait' : ''"
                  v-if="programs && programs.length && panel === PANELS.CARDS"
                  v-for="program in programs"
                  :key="program.program"
                  :id="'e'+program.program"
                  :class="{'has-status-bar--left has-status-bar--draft': scrollToEl === program.program}"
                  :stock="program"
                  :multiselection="multiselection"
                  :selectedItems="selectedItems"
                  :currentProgramPage='currentProgramPage'
                  @reload="$emit('resetFilters')"
                  @selectItem="v => $emit('selectItem', v)"
                  @selectItemToggleAll="items => $emit('selectItemToggleAll', items)"
      ></stock-program-card>

      <stock-program-list
                          :style="loading ? 'opacity: 0.4; cursor: wait' : ''"
                          v-if="programs && programs.length && panel === PANELS.TABLE"
                          :source="programs"
                          :currentProgramPage='currentProgramPage'
                          :multiselection="multiselection"
                          :selectedItems="selectedItems"
                          :totalPageParams="totalPage"
                          :paramsList='paramsList'
                          :infiniteLoadingParams="infiniteLoading"
                          @reload="$emit('resetFilters')"
                          @loadMore="$emit('loadMore')"
                          @sort="val => $emit('sortPrograms',val)"
                          @selectItem="v => $emit('selectItem', v)"
                          @selectItemToggleAll="items => $emit('selectItemToggleAll', items)"
      ></stock-program-list>

      <div v-if="(!programs || !programs.length) && !loading" class="is-border-left is-border-right  is-border-bottom has-bg-white column has-text-centered">
        <div v-if="hasFilter">
          <span class="subtitle" >Pas de résultat pour ces critères.</span>
          <br>
          <p class="is-margin-top" v-if="hasFilter"><a class="button is-primary" @click.prevent.stop="$emit('resetFilters')">Réinitialiser les filtres</a></p>
        </div>
        <span class="subtitle" v-else>Vous n'avez pas de stock visible. Veuillez vous rapprocher d'un administrateur.</span>
      </div>

      <!-- <div v-if="programs && programs.length && totalPage > 1"
        class="columns is-gapless is-margin-top-xsmall is-padding-left is-padding-right is-vcentered is-border is-margin-bottom-xsmall">
        <div class="column">&nbsp;</div>
        <pagination :loading="loading"
                    @ChangePage="changePage"
                    :currentPage="currentPage"
                    :totalPage="totalPage"
                    :reverse="true"></pagination>
      </div> -->
      <!-- <infinite-loading v-if="totalPage > 1 && nextPage && panel === PANELS.CARDS && !loading" spinner="waveDots" @infinite="val => $emit('loadMore', val)"></infinite-loading> -->
      <div class="is-border-top" v-if="totalPage > 1 && nextPage && panel === PANELS.CARDS && !loading">
        <a class="button is-light is-fullwidth has-text-grey" @click="$emit('loadMore', fromClick)" v-if="!infiniteLoading">
          <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
          <span class="is-size-6">Afficher la suite</span>
        </a>
        <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isEmpty } from 'lodash'
  import { mapState } from 'vuex'
  import StockProgramCard from './StockProgramCard.vue'
  import StockProgramList from './StockProgramList.vue'
  
  const PANELS = Object.freeze({
    CARDS: 'CARDS',
    TABLE: 'TABLE'
  })

  export default {
    name: 'StockProgramVue',
    components: {
      StockProgramCard,
      StockProgramList
    },
    data () {
      return {
        PANELS,
        panel: PANELS.CARDS,
        fromClick: true
      }
    },
    props: {
      sourcePrograms: Array,
      loading: Boolean,
      paramsList: Object,
      multiselection: {
        type: Boolean,
        default: false
      },
      selectedItems: {
        type: Array,
        default: () => []
      },
      currentProgramPage: Number
    },
    computed: {
      ...mapState(['scrollToEl']),
      sortBy () {
        return this.paramsList.sortBy
      },
      currentPage () {
        return this.paramsList.currentPage
      },
      totalPage () {
        return this.paramsList.totalPage
      },
      nextPage () {
        return this.paramsList.nextPage
      },
      infiniteLoading () {
        return this.paramsList.infiniteLoading
      },
      programs () {
        return this.sourcePrograms
      },
      lot_resume () {
        return this.sourcePrograms.lot_resume
      },
      hasFilter () {
        return this.paramsList.hasFilter
      }
    },
    methods: {
      changePanel (panel) {
        this.$store.commit('setScrollEl', null)
        this.$store.commit('setScrollPage', null)
        this.panel = panel
        this.changePage(1)
        this.$emit('changePanel', this.panel)
      },
      checkEmpty (val) {
        return !isEmpty(val)
      },
      changePage (e) {
        // this.$scrollTo('#programs-list')
        this.$emit('changePage', e)
      }
    },
    created () {
      if ('tab' in this.$route.query) {
        this.changePanel(this.$route.query.tab)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/stock/StockProgramVue.vue